import { ConfigOption, ProductsDataKeys } from 'services/types';
import './float-config-option.scss';
import useStateStore from 'services/store';
import { useEffect, useState, MouseEvent } from 'react';

type FloatConfigOptionProps = {
    item: ConfigOption;
    procedure: string;
    type?: ProductsDataKeys;
};

const FloatConfigOption = ({ item, procedure, type }: FloatConfigOptionProps) => {
    const { setProductFabric, activeProductData, runProcedure, activeFabric, setInnerFabric } =
        useStateStore();
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (type) {
            if (type === 'inner-fabric') {
                const innerFabrics = activeProductData[activeFabric]['inner-fabric'];
                const placements = innerFabrics.innerPlacement;
                const activePlacement = innerFabrics.activePlacement;
                if (placements?.[activePlacement!].fabricId === item.id) {
                    setIsActive(true);
                } else {
                    setIsActive(false);
                }
            } else {
                if (activeProductData?.[activeFabric]?.[type].value === item.id) {
                    setIsActive(true);
                } else {
                    setIsActive(false);
                }
            }
        }
    }, [activeProductData, activeFabric]);

    const handleClickOption = (e: MouseEvent, item: ConfigOption) => {
        e.preventDefault();
        const divTarget = e.currentTarget as HTMLDivElement;
        const imgTag = divTarget.querySelector('img');
        let src: string = '';
        if (imgTag) {
            src = imgTag.src;
        }
        runProcedure(procedure, item, type, src);
        if (type === 'fabric') {
            setProductFabric({ value: item.id, name: item.name, price: item.price }, type, src);
        } else if (type === 'inner-fabric') {
            setInnerFabric('inner-fabric', item.id, src!);
        } else {
            setProductFabric({ value: item.id }, type, src);
        }
    };

    return (
        <div
            key={item.id}
            onClick={(e) => handleClickOption(e, item)}
            className={`option-item ${isActive ? 'active' : ''}`}
        >
            <div className="option-container">
                <div className="image">
                    <img src={item.img} alt="" />
                </div>
                <div className="item-info">
                    <div className="left">
                        <div className="name">{item.name}</div>
                        <div className="details">{type !== 'inner-fabric' && item?.details}</div>
                    </div>
                    <div className="right">{type !== 'inner-fabric' && item?.price}</div>
                </div>
            </div>
        </div>
    );
};

export default FloatConfigOption;
